import type { RegionNode } from '../../../../api/regions';

// Generic region-tree helpers live in src/utils (shared with the venues feature).
export { flattenById, subtreeIds, regionChainNames } from '../../../../utils/regionTree';

export interface RootInfo {
  rootId: string | null;
  rootName: string;
  isRootSelected: boolean;
}

/** Walk parentId up the flat node map to find a region's root. */
export function resolveRoot(byId: Map<string, RegionNode>, regionId: string | null): RootInfo {
  let node = regionId ? byId.get(regionId) : undefined;
  if (!node) return { rootId: null, rootName: '', isRootSelected: false };
  const isRootSelected = node.parentId === null;
  while (node.parentId && byId.has(node.parentId)) node = byId.get(node.parentId)!;
  return { rootId: node.id, rootName: node.name, isRootSelected };
}
